import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {MetadataReportSubModel, VenViewModel} from 'src/app/model/vens.model';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';
import {extractErrorMessage} from "../../../common/common";
import {LoaderComponent} from "../../common/loader/loader.component";

@Component({
  selector: 'app-register-reports',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, LoaderComponent],
  templateUrl: './register-report.component.html',
  styleUrl: './register-report.component.scss'
})
export class RegisterReportComponent implements OnInit {
  protected isLoading: boolean = false;

  protected metadata_report_ids: any[] = [];
  protected vens: VenViewModel[] = [];

  protected venSelected: VenViewModel | undefined;
  protected metadata_reports: MetadataReportSubModel[] | null = [];

  protected result: string = '';
  protected error: string | null = null;

  constructor(private injector: Injector, private registerReportService: ApiService) {}

  ngOnInit(): void {
    // Fetch only 2.0b VENs that have a registration-index and metadata reports
    const queryParams: CustomHttpParams = {
      'depths': JSON.stringify({
        "registration": 1,
        "metadata_reports": 1,
      }),
      'profile': '2.0b',
    };
    this.isLoading = true;
    this.registerReportService.findVens(queryParams).subscribe({
      next: (response: VenViewModel[]) => {
        this.vens = response
          .filter((ven: any) => ven.registration && ven.metadata_reports?.length > 0);
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.error = extractErrorMessage(err, "Failed to load VENs.");
        this.isLoading = false;
      }
    });
  }

  performAction() {
    if (!this.venSelected) {
      this.error = "Please select a VEN.";
      return;
    }

    this.error = null;

    const data = {
      vens: this.venSelected,
      metadata_report_ids: this.metadata_report_ids && this.metadata_report_ids.length > 0 ?
        this.metadata_report_ids :
        (this.venSelected.metadata_reports || []).map((report: any) => report.id),
      ven_id: this.venSelected.id,
    };
    this.isLoading = true;

    this.registerReportService.registerReports(data).subscribe({
      next: (_: any) => {
        this.result = "Successfully sent report registration.";
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.error = extractErrorMessage(err, "An error occurred while registering reports.");
        this.isLoading = false;
      }
    });
  }

  setVens(event: any) {
    this.venSelected = this.vens.find((ven) => ven.id === Number(event.value));
    this.metadata_reports = this.venSelected?.metadata_reports ?? [];

    // Reset selected metadata reports when changing VEN
    this.metadata_report_ids = [];
  }

  metadata(event: any) {
    this.metadata_report_ids = Array.from(event.options)
      .filter((ev: any) => ev.selected)
      .map((evtSelected: any) => Number(evtSelected.value));
  }
}
